// import React, { useState, useEffect } from 'react';
// import { BASE_URL } from '../../constant/api';

// function CustomerImageGrid({ productImages, brandName, brandLogo }) {
//   const [selectedImage, setSelectedImage] = useState(null); // State for the main image

//   const getImageUrl = (image) => {
//     if (!image) return "/images/default-product.png";
//     return image.includes(BASE_URL) ? image : `${BASE_URL}${image}`;
//   };

//   // Set the first image as the default selected image
//   useEffect(() => {
//     if (productImages?.length) {
//       setSelectedImage(productImages[0].image); // Default to the first image
//     }
//   }, [productImages]);

//   return (
//     <div className="lg:bg-gray-100 ml-10 bg-gray-100 h-[300px] lg:h-[390px] rounded-xl lg:w-full flex flex-col lg:flex-row gap-2 items-center lg:items-start">
//     {/* Main Product Image Section */}
//     <div className="w-full mt-8 mb-6">
//       <img
//         src={getImageUrl(selectedImage)}
//         alt="Product"
//         className="size-52 lg:size-80 ml-4 lg:ml-14 object-contain max-w-full rounded-lg"
//       />
  
//       {/* Brand Info Section */}
//       <div className="mt-16 flex items-center justify-start gap-2">
//         <p className="font-semibold text-sm text-gray-800">{brandName }</p>
//         {brandLogo ? (
//   <img
//     src={getImageUrl(brandLogo)}
//     alt="Brand Logo"
//     className="w-12 h-12 rounded-md"
//   />
// ) : null}

//       </div>
//     </div>
  
//     {/* Thumbnails Section */}
//     <div className="flex flex-row md:flex-col gap-4 w-full md:w-1/3 h-fit overflow-x-auto md:overflow-x-hidden overflow-y-hidden md:overflow-y-auto mt-5">
//       {productImages?.map((img, idx) => (
//         <div key={idx} className="h-20 w-20 flex-shrink-0">
//           <img
//             src={getImageUrl(img.image)}
//             alt="Thumbnail"
//             className={`w-full h-full object-contain rounded-lg cursor-pointer transition ease-in-out duration-300 
//               ${getImageUrl(img.image) === getImageUrl(selectedImage)
//                 ? "border-2 border-brand-primary"
//                 : "border"
//               }`}
//             onClick={() => setSelectedImage(img.image)} // Set the clicked image as the main image
//           />
//         </div>
//       ))}
//     </div>
//   </div>
  
//   );
// }

// export default CustomerImageGrid;
import React, { useState, useEffect } from 'react';
import { 
  IoChevronBack as ChevronLeft, 
  IoChevronForward as ChevronRight, 
  IoAdd as ZoomIn, 
  IoRemove as ZoomOut, 
  IoRefresh as RotateCw, 
  IoDownload as Download, 
  IoShareSocial as Share2, 
  IoHeart as Heart, 
  IoEye as Eye,
  IoClose
} from 'react-icons/io5';
import { BASE_URL } from '../../constant/api';

function CustomerImageGrid({ productImages = [], brandName = '', brandLogo = '' }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isFavorited, setIsFavorited] = useState(false);
  const [viewCount, setViewCount] = useState(0);

  const getImageUrl = (image) => {
    if (!image) return "/images/default-product.png";
    return image.includes(BASE_URL) ? image : `${BASE_URL}${image}`;
  };

  useEffect(() => {
    if (productImages.length > 0) {
      setSelectedImage(productImages[0].image);
      setSelectedIndex(0);
    }
  }, [productImages]);

  const handleImageSelect = (image, index) => {
    setSelectedImage(image);
    setSelectedIndex(index);
    setZoom(1);
    setRotation(0);
    setViewCount(prev => prev + 1);
  };

  const handlePrevImage = () => {
    const prevIndex = selectedIndex > 0 ? selectedIndex - 1 : productImages.length - 1;
    handleImageSelect(productImages[prevIndex].image, prevIndex);
  };

  const handleNextImage = () => {
    const nextIndex = selectedIndex < productImages.length - 1 ? selectedIndex + 1 : 0;
    handleImageSelect(productImages[nextIndex].image, nextIndex);
  };

  const handleZoomIn = () => setZoom(prev => Math.min(prev + 0.25, 3));
  const handleZoomOut = () => setZoom(prev => Math.max(prev - 0.25, 0.5));
  const handleRotate = () => setRotation(prev => (prev + 90) % 360);
  const handleReset = () => {
    setZoom(1);
    setRotation(0);
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = getImageUrl(selectedImage);
    link.download = `product-image-${selectedIndex + 1}.jpg`;
    link.click();
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `${brandName} Product Image`,
          url: getImageUrl(selectedImage)
        });
      } catch (err) {
        console.log('Error sharing:', err);
      }
    } else {
      // Fallback: copy to clipboard
      navigator.clipboard.writeText(getImageUrl(selectedImage));
      alert('Image URL copied to clipboard!');
    }
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  if (isFullscreen) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-95 z-50 flex items-center justify-center">
        <div className="relative w-full h-full flex items-center justify-center p-4">
          {/* Close button */}
          <button
            onClick={toggleFullscreen}
            className="absolute top-4 right-4 z-10 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 rounded-full transition-all"
          >
            <IoClose size={24} />
          </button>
          
          {/* Navigation arrows */}
          {productImages.length > 1 && (
            <>
              <button
                onClick={handlePrevImage}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-3 rounded-full transition-all"
              >
                <ChevronLeft size={24} />
              </button>
              <button
                onClick={handleNextImage}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-3 rounded-full transition-all"
              >
                <ChevronRight size={24} />
              </button>
            </>
          )}
          
          {/* Controls */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
            <button 
              onClick={handleZoomOut} 
              disabled={zoom <= 0.5}
              className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 rounded transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <ZoomOut size={20} />
            </button>
            <button 
              onClick={handleZoomIn} 
              disabled={zoom >= 3}
              className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 rounded transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <ZoomIn size={20} />
            </button>
            <button onClick={handleRotate} className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 rounded transition-all">
              <RotateCw size={20} />
            </button>
            <button onClick={handleReset} className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-2 rounded text-sm transition-all">
              Reset
            </button>
          </div>
          
          {/* Main image */}
          <img
            src={getImageUrl(selectedImage)}
            alt="Product Fullscreen"
            className="max-w-full max-h-full object-contain transition-transform duration-300"
            style={{
              transform: `scale(${zoom}) rotate(${rotation}deg)`,
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
        {/* Main Image Section */}
        <div className="lg:col-span-4 order-2 lg:order-1">
          {/* Main Image Container - Square */}
          <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-6 border-2 border-gray-200 hover:border-gray-300 transition-all duration-300">
            {/* Image counter */}
            <div className="absolute top-4 left-4 bg-black bg-opacity-60 text-white px-3 py-1 rounded-full text-sm font-medium z-10">
              {selectedIndex + 1} / {productImages.length}
            </div>
            
            {/* Action buttons */}
            <div className="absolute top-4 right-4 flex gap-2 z-10">
              <button
                onClick={() => setIsFavorited(!isFavorited)}
                className={`p-2 rounded-full transition-all duration-200 ${
                  isFavorited 
                    ? 'bg-red-500 text-white hover:bg-red-600' 
                    : 'bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-700 hover:text-red-500'
                }`}
                title={isFavorited ? "Remove from favorites" : "Add to favorites"}
              >
                <Heart size={18} fill={isFavorited ? "currentColor" : "none"} />
              </button>
              <button
                onClick={toggleFullscreen}
                className="p-2 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-700 hover:text-blue-500 rounded-full transition-all duration-200"
                title="View fullscreen"
              >
                <Eye size={18} />
              </button>
              <button
                onClick={handleShare}
                className="p-2 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-700 hover:text-green-500 rounded-full transition-all duration-200"
                title="Share image"
              >
                <Share2 size={18} />
              </button>
              <button
                onClick={handleDownload}
                className="p-2 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-700 hover:text-purple-500 rounded-full transition-all duration-200"
                title="Download image"
              >
                <Download size={18} />
              </button>
            </div>

            {/* Navigation arrows */}
            {productImages.length > 1 && (
              <>
                <button
                  onClick={handlePrevImage}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-700 p-3 rounded-full shadow-lg transition-all duration-200 hover:scale-105 z-10"
                  title="Previous image"
                >
                  <ChevronLeft size={24} />
                </button>
                <button
                  onClick={handleNextImage}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-700 p-3 rounded-full shadow-lg transition-all duration-200 hover:scale-105 z-10"
                  title="Next image"
                >
                  <ChevronRight size={24} />
                </button>
              </>
            )}

            {/* Square image display container with overflow hidden for zoom containment */}
            <div className="relative w-full aspect-square bg-white rounded-lg overflow-hidden flex items-center justify-center">
              <img
                src={getImageUrl(selectedImage)}
                alt="Product"
                className="w-full h-full object-cover transition-all duration-300 cursor-pointer"
                style={{
                  transform: `scale(${zoom}) rotate(${rotation}deg)`,
                  transformOrigin: 'center center'
                }}
                onClick={toggleFullscreen}
              />
            </div>
          </div>

          {/* Image controls */}
          <div className="mt-4 flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-2 flex-wrap">
              <button
                onClick={handleZoomOut}
                disabled={zoom <= 0.5}
                className="flex items-center gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg transition-all duration-200"
                title="Zoom out"
              >
                <ZoomOut size={16} />
                <span className="text-[11px]">Zoom Out</span>
              </button>
              <button
                onClick={handleZoomIn}
                disabled={zoom >= 3}
                className="flex items-center gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg transition-all duration-200"
                title="Zoom in"
              >
                <ZoomIn size={16} />
                <span className="text-[11px]">Zoom In</span>
              </button>
              <button
                onClick={handleRotate}
                className="flex items-center gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-all duration-200"
                title="Rotate image"
              >
                <RotateCw size={16} />
                <span className="text-[11px]">Rotate</span>
              </button>
              <button
                onClick={handleReset}
                className="px-2 py-2 text-[11px] bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-all duration-200 text-sm font-medium"
                title="Reset view"
              >
                Reset View
              </button>
            </div>
          </div>

          {/* Brand Information */}
          {(brandName || brandLogo) && (
            <div className="mt-6 flex items-center gap-4">
              {brandLogo && (
                <div className="w-16 h-16 bg-white rounded-lg flex items-center justify-center shadow-sm border">
                  <img
                    src={getImageUrl(brandLogo)}
                    alt="Brand Logo"
                    className="max-w-12 max-h-12 object-contain"
                  />
                </div>
              )}
              {brandName && (
                <div>
                  <span className="font-semibold text-gray-800 text-lg">{brandName}</span>
                  <p className="text-sm text-gray-600 mt-1">Official Brand</p>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Thumbnails Section */}
        <div className="lg:col-span-1 order-1 lg:order-2">
        
          <div className="flex lg:flex-col gap-3 overflow-x-auto lg:overflow-x-visible pb-2 lg:pb-0">
            {productImages.map((img, index) => (
              <div key={index} className="flex-shrink-0 relative group">
                <button
                  onClick={() => handleImageSelect(img.image, index)}
                  className={`block w-24 h-24 lg:w-full lg:h-24 rounded-xl overflow-hidden border-3 transition-all duration-300 ${
                    getImageUrl(img.image) === getImageUrl(selectedImage)
                      ? 'border-blue-500 shadow-lg scale-105 ring-2 ring-blue-200'
                      : 'border-gray-200 hover:border-gray-400 hover:shadow-md hover:scale-102'
                  }`}
                >
                  <img
                    src={getImageUrl(img.image)}
                    alt={`Product ${index + 1}`}
                    className="w-full h-full object-cover bg-gray-50 transition-transform group-hover:scale-110"
                  />
                </button>
                {/* Thumbnail overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-xl flex items-center justify-center">
                  <Eye className="text-white opacity-0 group-hover:opacity-100 transition-opacity" size={16} />
                </div>
                {/* Active indicator */}
                {getImageUrl(img.image) === getImageUrl(selectedImage) && (
                  <div className="absolute -top-1 -right-1 w-4 h-4 bg-blue-500 rounded-full border-2 border-white"></div>
                )}
              </div>
            ))}
          </div>
          
          {/* Image info panel */}
         
        </div>
      </div>
    </div>
  );
}

export default CustomerImageGrid;